/* eslint-disable import/no-named-as-default-member */
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Collapse } from "@material-ui/core";
import { ButtonIcon, SecondaryButton, ButtonSizeOptions, ICONS } from "@loanbossinc/component-library";
import {
    getConfigItemByParentId,
    createConfigItem,
    updateConfigItem,
    deleteConfigItem,
    createConfigItemAction,
    getConfigItemActions,
    updateConfigItemAction,
    deleteConfigItemAction
} from 'store/state/configItems';
import { SimpleInfoModal } from 'modals/SimpleInfoModal';
import { UpsertModal } from './UpsertModal';
import { PageContainer, TitleBar, ModuleWrapper, TitleWrapper, RowWrapper, Module, ButtonWrapper, StyledButtonIcon, TextWrapper } from './styles';
import { BORROWER_LIST_OF_DOCUMENTS, GUARANTOR_LIST_OF_DOCUMENTS, DOC_MODAL, SIMPLE_INFO_MODAL, SYSTEM_ACTIONS, SYSTEM_ACTION_IDS, REQUIRED_CALCULATIONS } from './constants';
import { getNewItem, getModalTitle } from './util';

class FinancialReporting extends Component {
    state = {
        openModal: { name: null, data: null, title: "" },
        selectedItem: {},
        newDocumentType: "",
        requiredCalculations: { isExpanded: true },
        borrowerDocuments: { isExpanded: true },
        guarantorDocuments: { isExpanded: false },
        confirmationModal: {
            title: "",
            onClose: () => { },
            onAccept: () => { },
            content: "",
        },
        systemActionOptions: [],
        companyId: null
    };

    componentDidMount = () => {
        this.getConfigItems();
    };

    componentDidUpdate = (prevProps) => {
        if (prevProps.systemActions !== this.props.systemActions && !!this.props.systemActions) {
            const systemActionOptions = this.props.systemActions.map(({ id, name, sortOrder }) => ({
                value: id,
                label: name,
                sortOrder
            })).sort((a, b) => a.sortOrder - b.sortOrder);
            this.setState({ systemActionOptions: [...systemActionOptions, { value: null, label: 'No Action', sortOrder: systemActionOptions.length + 1 }] });
        };
    };

    getConfigItems = () => {
        this.props.getConfigItemByParentId({ id: REQUIRED_CALCULATIONS, refresh: true });
        this.props.getConfigItemByParentId({ id: BORROWER_LIST_OF_DOCUMENTS, refresh: true });
        this.props.getConfigItemByParentId({ id: GUARANTOR_LIST_OF_DOCUMENTS, refresh: true });
        this.props.getConfigItemByParentId({ id: SYSTEM_ACTIONS, refresh: true });
        this.props.getConfigItemActions({ companyId: this.props.authentication.user.contact.companyId });
    };

    addDocument = (type) => {
        this.setState({ newDocumentType: type, selectedItem: getNewItem(type) });
        const title = getModalTitle("Add", type);
        this.openModal(DOC_MODAL, null, title);
    };

    updateDocument = (type, item) => {
        this.setState({ newDocumentType: '', selectedItem: item });
        const title = getModalTitle("Update", type);
        this.openModal(DOC_MODAL, null, title);
    };

    deleteDocument = (item) => {
        const { authentication } = this.props;
        const companyId = this.props.authentication.user.contact.companyId;
        if (!authentication || authentication.isGuest || !authentication.isSystemAdmin) return null;
        this.openConfirmationDialog(
            "Delete Item",
            this.closeModal,
            () => {
                if (item && item.id) {
                    this.props.deleteConfigItem({ id: item.id, callback: this.getConfigItems });
                    this.props.deleteConfigItemAction({ id: item.systemActionId, companyId, callback: () => this.props.getConfigItemActions({companyId}) });
                };

                this.closeModal();
            },
            (<><p>Are you sure that you want to delete this Document?</p> <p>This action cannot be undone.</p></>)
        );
    };

    openConfirmationDialog = (title, onClose, onAccept, content) => {
        this.setState({ confirmationModal: { title, onClose, onAccept, content } });
        this.openModal(SIMPLE_INFO_MODAL);
    };

    saveChanges = () => {
        const { createConfigItem, updateConfigItem, updateConfigItemAction, createConfigItemAction, getConfigItemActions } = this.props;
        const companyId = this.props.authentication.user.contact.companyId;
        const { selectedItem } = this.state;
        const { id, systemActionId, systemAction } = selectedItem;
        if (id === "new") {
            // Since a config item action has a foreign key based on the config item id, creating a new config item needs to exist before
            // creating a new config item action. createConfigItem has been modified to handle that.
            createConfigItem({ item: selectedItem, companyId, callback: this.getConfigItems });
        } else {
            updateConfigItem({ item: selectedItem, callback: this.getConfigItems });
            if (systemActionId){
                updateConfigItemAction({ id: systemActionId, companyId, configItemActionId: systemAction, configItemDocId: id, callback: () => getConfigItemActions({companyId}) });
            }
            if (!systemActionId && systemAction){
                createConfigItemAction({ companyId, configItemActionId: systemAction, configItemDocId: id, callback: () => getConfigItemActions({companyId}) });
            }
        };

        this.closeModal();
    };

    itemChanged = (event) => {
        let item = this.state.selectedItem;
        item.name = event?.target?.value;
        item.value = event?.target?.value;
        item.sortOrder = 0;
        this.setState({ selectedItem: item });
    };

    handleSystemActionChange = (event) => {
        let selectedItem = this.state.selectedItem;
        selectedItem.systemAction = event?.value;
        this.setState({ selectedItem });
    };

    openModal = (name, data = null, title = "") => this.setState({ openModal: { name, data, title } });

    closeModal = () => this.setState({ openModal: { name: null, data: null } });

    isModalOpen = (modalName) => this.state.openModal.name === modalName;

    expandmodule = (moduleName) => {
        this.setState({ [moduleName]: { isExpanded: !this.state[moduleName].isExpanded }, selectedItem: {} })
    };

    renderDocGrid = (docs, title, moduleName) => {
        if (!docs || docs.length === 0) return null;

        const isRequiredCalculationsModule = moduleName === "requiredCalculations";

        const sortedDocs = docs.sort((a, b) => a.value.localeCompare(b.value));

        const sortedDocsWithActions = sortedDocs.map(doc => {
            if (!this.props.configItemActions) return ({ ...sortedDocs });
            const matchingAction = this.props.configItemActions.find(action => action.configItemDocId === doc.id);
            return matchingAction ?
                ({
                    ...doc,
                    systemActionId: matchingAction.id,
                    systemAction: matchingAction.configItemActionId
                }) : ({
                    ...doc,
                    systemActionId: null,
                    systemAction: null
                });
        });
        return (
            <Module>
                <TitleWrapper>
                    <div className="title">{title}</div>
                      <div className="button">
                      {!isRequiredCalculationsModule && (
                        <SecondaryButton
                            label="Add Document"
                            size={ButtonSizeOptions.smFluid}
                            onClick={() => this.addDocument(moduleName)}
                        />
                      )}
                        <ButtonIcon onClick={() => this.expandmodule(moduleName)} iconName={this.state[moduleName].isExpanded ? ICONS.UNFOLD_LESS : ICONS.UNFOLD_MORE} />
                    </div>
                </TitleWrapper>
                {sortedDocsWithActions.map(doc => (
                    <Collapse in={this.state[moduleName].isExpanded}>
                        <RowWrapper>
                            <TextWrapper>
                                <div className="text">{doc.value}</div>
                                {doc.systemAction && <div className='text red'>[Action: {SYSTEM_ACTION_IDS[doc.systemAction]}]</div>}
                            </TextWrapper>
                            {!isRequiredCalculationsModule && (
                                <ButtonWrapper>
                                    <StyledButtonIcon iconName="edit" onClick={() => this.updateDocument(moduleName, doc)} />
                                    <StyledButtonIcon iconName="delete" onClick={() => this.deleteDocument(doc)} />
                                </ButtonWrapper>
                            )}
                        </RowWrapper>
                    </Collapse>))}
            </Module>
        )
    };

    render() {
        const { requiredCalculations, guarantorDocuments, borrowerDocuments } = this.props;

        return (
            <>
                <PageContainer>
                    <TitleBar>FINANCIAL REPORTING</TitleBar>
                    <ModuleWrapper>{this.renderDocGrid(requiredCalculations, "Required Calculations", "requiredCalculations")}</ModuleWrapper>
                    <ModuleWrapper>{this.renderDocGrid(borrowerDocuments, "Borrower Documents", "borrowerDocuments")}</ModuleWrapper>
                    <ModuleWrapper>{this.renderDocGrid(guarantorDocuments, "Guarantor Documents", "guarantorDocuments")}</ModuleWrapper>
                </PageContainer>
                <UpsertModal
                    title={this.state.openModal.title}
                    content={this.state.selectedItem}
                    isOpen={this.isModalOpen(DOC_MODAL)}
                    onClose={this.closeModal}
                    onAccept={this.saveChanges}
                    onChange={this.itemChanged}
                    onSystemActionChange={this.handleSystemActionChange}
                    systemActionOptions={this.state.systemActionOptions}
                />
                <SimpleInfoModal
                    title={this.state.confirmationModal.title}
                    isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
                    onClose={() => this.state.confirmationModal.onClose()}
                    onAccept={() => this.state.confirmationModal.onAccept()}
                    content={this.state.confirmationModal.content}
                />
            </>
        );
    };
}

const mapStateToProps = ({ authentication, configItems }) => {
    return {
        authentication,
        requiredCalculations: configItems.configItemByParent[REQUIRED_CALCULATIONS],
        guarantorDocuments: configItems.configItemByParent[GUARANTOR_LIST_OF_DOCUMENTS],
        borrowerDocuments: configItems.configItemByParent[BORROWER_LIST_OF_DOCUMENTS],
        systemActions: configItems.configItemByParent[SYSTEM_ACTIONS],
        configItemActions: configItems.configItemActions
    };
}

export default compose(
    connect(
        mapStateToProps,
        {
            getConfigItemByParentId,
            createConfigItem,
            updateConfigItem,
            deleteConfigItem,
            createConfigItemAction,
            getConfigItemActions,
            updateConfigItemAction,
            deleteConfigItemAction
        }
    )
)(FinancialReporting);
